export const getTextFieldOverrides = (theme, typography) => {
  return {
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: `${theme.spacing(1)}`
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          ...typography.body.body2,
          color: theme.palette.primary.dark,
          borderRadius: 8,
          height: 56,
          padding: 16,
          marginTop: `${theme.spacing(2.7)}`,
          border: `1px solid ${theme.palette.secondary.dark}`,
          transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
          maxWidth: "100%",
          "&.Mui-disabled": {
            border: `1px solid ${theme.palette.grey[1]}`
          }
        },
        input: {
          "&:-webkit-autofill": {
            transitionDelay: "9999s",
            transitionProperty: "background-color, color"
          },
          "&.Mui-disabled&.MuiInputBase-inputAdornedEnd": {
            paddingRight: 8,
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        }
      },
      variants: [{
        props: {
          variant: "outlined",
          disabled: false,
          focused: false
        },
        style: {
          borderColor: theme.palette.secondary.dark
        }
      }, {
        props: {
          variant: "outlined",
          disabled: false,
          focused: true
        },
        style: {
          borderColor: theme.palette.primary.light
        }
      }, {
        props: {
          variant: "outlined",
          disabled: false,
          error: true
        },
        style: {
          borderColor: theme.palette.error.dark
        }
      }]
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          ...typography.body.caption,
          transform: "none",
          color: theme.palette.grey[4],
          maxWidth: "100%",
          lineHeight: "18px",
          "&.Mui-focused": {
            color: theme.palette.grey[4]
          },
          "&.Mui-error": {
            color: theme.palette.error.dark
          },
          "&.Mui-disabled": {
            color: theme.palette.text.disabled
          }
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          ...typography.body.caption,
          color: theme.palette.grey[3],
          maxWidth: "100%",
          transformOrigin: "bottom left",
          whiteSpace: "nowrap",
          display: "block",
          position: "absolute",
          bottom: `-${theme.spacing(2.7)}`,
          lineHeight: "16px",
          "&.Mui-error": {
            color: theme.palette.error.dark
          },
          "&.Mui-disabled": {
            color: theme.palette.text.disabled
          }
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.dark,
          cursor: "pointer",
          "&.Mui-disabled": {
            color: theme.palette.text.disabled,
            cursor: "auto"
          }
        }
      }
    }
  };
};